import { types, isType } from "mobx-state-tree"
export const Event = types.model({
    _id: types.identifier,
    bytes32Id: types.string,
    teams: types.array(types.string),
    drawPossible: types.boolean,
    maker: types.string,
    makerBond: types.number,
    categoryId: types.string,
    leagueId: types.string,
    cancelled: types.boolean,
    //locked: types.boolean,
    startTime: types.number,
    duration: types.number,
    finalized: types.optional(types.boolean, false),
    //endTime: types.number,
    betsForTeam: types.array(types.optional(types.number, 0)),
    betsForDraw: types.optional(types.number, 0),
    //   betsForTeamTwo: types.number,
    amountBetForTeam: types.array(types.optional(types.number, 0)),
    amountBetForDraw: types.optional(types.number, 0),
    //amountBetForTwo: types.number,
    teamColors: types.optional(types.array(types.optional(types.string, "rgb(255,255,255)")), []),
    //teamTwoColor: types.optional(types.string, "rgb(0,0,0)"),
    isPropEvent: types.optional(types.boolean, false),
    relatedPropEvents: types.optional(types.array(types.string), []),
    originalEventId: types.optional(types.string, ""),
    propTitle: types.optional(types.string, ""),
    votesForTeam: types.array(types.optional(types.number, 0)),
    //votesForTeamTwo: types.optional(types.number, 0),
    votesForDraw: types.optional(types.number, 0),
    votesForIndeterminate: types.optional(types.number, 0)
    
});


// WEBPACK FOOTER //
// ./src/models/Event.js